<template>
  <v-card class="elevation-12">
    <v-toolbar  dark flat >
        <v-toolbar-title>{{ $t('welcome.quickrights') }}</v-toolbar-title>
        <v-spacer></v-spacer>
    </v-toolbar>
    <v-card-text>
      <v-form ref="form" onSubmit="return false;">
        <v-text-field
          v-if="email_field.active"
          id="email"
          label="Email"
          name="email"
          :rules="[rules.required,rules.email]"
          prepend-icon="email"
          type="text"
          v-model="email_field.value"
          @keyup.enter="onLogin()"
        ></v-text-field>

        <v-text-field
          v-if="otp.active"
          id="otp"
          label="OTP"
          name="otp"
          :rules="[rules.required,rules.exact_length(6)]"
          prepend-icon="mdi-folder-lock"
          type="password"
          persistent-hint
          :hint="$t('login.otp.sent.message')"
          v-model="otp.value"
          @keyup.enter="verifyOtp()"
        ></v-text-field>
      </v-form>
    </v-card-text>
    <v-card-actions class="justify-center">
      <v-btn
        v-if="email_field.button.active"
        :loading="email_field.button.loading"
        @click="onLogin"
        color="primary"
        round
      >{{ $t('rms.button.login') }}</v-btn>

      <v-btn
        v-if="otp.active"
        :loading="otp.button.loading"
        color="primary"
        @click="verifyOtp"
        round
      >{{$t('rms.button.verify')}}</v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>
import rules from "@/validation";
import { mapState } from "vuex";
export default {
  data() {
    return {
      rules,
      email_field: {
        active: true,
        value: "",
        button: {
          active: true,
          loading: false
        }
      },
      otp: {
        active: false,
        value: "",
        button: {
          loading: false
        }
      }
    };
  },

  computed: {
    ...mapState({
      session_key: state => state.auth.key
    })
  },

  methods: {
    activeOtpField() {
      this.otp.active = true;
      this.otp.value = "";
      this.email_field.button.active = false;
    },

    activeEmailField() {
      this.otp.active = false;
      this.otp.button.loading = false;
      this.email_field.button.active = true;
      this.email_field.button.loading = false;
    },

    // sending OTP
    async onLogin() {
      if (!this.$refs.form.validate()) {
        return false;
      }
      this.email_field.button.loading = true;
      try {
        var data = await this.$store.dispatch("auth/login", {
          email: this.email_field.value
        });
        this.activeOtpField();

        this.$store.dispatch("app/showMessage", {
          message: "Otp sent successfully !",
          color: "green"
        });
      } catch (error) {
        this.activeEmailField();
        this.$store.dispatch("app/showMessage", {
          message: error.message,
          color: "error"
        });
      }
    },
    // verifying otp
    async verifyOtp() {
      if (!this.$refs.form.validate()) {
        return false;
      }
      this.otp.button.loading = true;
      try {
        var data = await this.$store.dispatch("auth/verifyOtp", {
          otp: this.otp.value,
          key: this.session_key
        });
        this.otp.button.loading = false;
        this.$store.dispatch("auth/loginSuccess", data);
      } catch (error) {
        this.activeEmailField();
        this.$store.dispatch("app/showMessage", {
          message: error.message,
          color: "error"
        });
      }
    }
  }
};
</script>


